import React from 'react';
import { GitCompareIcon } from 'lucide-react';
import { Card } from '../sf/Card';
export function ChangeSummaryCard({
  changes
}: {
  changes: string[];
}) {
  return <Card title="Change summary vs v1" icon={GitCompareIcon} iconBg="#F49756" data-id="element-75" data-mp="2aei0z74835wj">
      <ul className="list-disc space-y-1.5 pl-5 text-[13px] text-sf-text marker:text-sf-weak" data-id="element-76" data-mp="2femi8zcyg4nt">
        {changes.map(change => <li key={change} data-id="element-77" data-mp="2p60qpwmvwet3">{change}</li>)}
      </ul>
    </Card>;
}